import {renderRoutes, matchRoutes} from 'react-router-config';
import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {useCookieExists} from '@wr/ui-patterns';
import assetUrl from '../utils/assetUrl';
import {
    getCountryCode, getTranslations, isLoggedIn, getWebRelaunchStyleEnabled, getLanguageChooserDisabled
} from '../utils/selectors';
import GenericErrorMessage from './molecules/GenericErrorMessage';
import {Footer} from './organisms';
import PlatformTemplate from './organisms/PlatformTemplate';
import ErrorBoundary from './ErrorBoundary';
import {genericErrorHasOccurred} from '../actions/generic-error/action-creators';
import {GENERIC_ERROR_TYPES} from '../consts';

export const Root = props => {
    const {
        dispatch,
        countryCode,
        commonPageData,
        location,
        loggedIn,
        route,
        isWebRelaunchStyleEnabled,
        isLanguageChooserDisabled,
        featureFlags: {newHeaderLogo},
        serverSideProps
    } = props;
    const {routes} = route;

    const sessionExists = useCookieExists('sessionExists');

    useEffect(() => {
        if (!sessionExists) {
            dispatch(genericErrorHasOccurred(true, GENERIC_ERROR_TYPES.session));
        }
    }, [sessionExists]);

    const logoName = isWebRelaunchStyleEnabled || newHeaderLogo.enabled ?
        'images/logo-web-relaunch.svg' :
        'images/logo.svg';

    const routerMatch = matchRoutes(routes, props.location.pathname);
    const {rootSectionClassName} = routerMatch[0].route;
    const disableHeaderAndFooter = props.location.pathname.includes('gotoapp');

    return (
        <ErrorBoundary>
            <section className={rootSectionClassName}>
                <PlatformTemplate
                    countryCode={countryCode}
                    commonPageData={commonPageData}
                    location={location}
                    loggedIn={loggedIn}
                    logoUrl={assetUrl(logoName)}
                    logoSmallUrl={assetUrl('images/logo-small.svg')}
                    isWebRelaunchStyleEnabled={isWebRelaunchStyleEnabled}
                    isDisabledLanguageChooser={isLanguageChooserDisabled}
                    disableHeader={disableHeaderAndFooter}
                >
                    <main>
                        <GenericErrorMessage />
                        {renderRoutes(routes, serverSideProps)}
                    </main>
                </PlatformTemplate>
                {!disableHeaderAndFooter && <Footer {...props} />}
            </section>
        </ErrorBoundary>
    );
};

Root.propTypes = {
    route: PropTypes.shape({
        routes: PropTypes.arrayOf(PropTypes.object)
    }).isRequired,
    isWebRelaunchStyleEnabled: PropTypes.bool,
    isLanguageChooserDisabled: PropTypes.bool,
    commonPageData: PropTypes.shape({
        csrfToken: PropTypes.string.isRequired,
        localisation: PropTypes.shape().isRequired,
        customer: PropTypes.shape().isRequired,
        isWebView: PropTypes.bool.isRequired,
        platformData: PropTypes.shape({
            isMobile: PropTypes.bool.isRequired
        }).isRequired
    }).isRequired,
    featureFlags: PropTypes.shape({
        newHeaderLogo: PropTypes.shape().isRequired
    }).isRequired,
    translations: PropTypes.shape().isRequired
};

Root.defaultProps = {
    isWebRelaunchStyleEnabled: false,
    isLanguageChooserDisabled: false
};

const mapStateToProps = state => ({
    commonPageData: state.commonPageData,
    countryCode: getCountryCode(state),
    loggedIn: isLoggedIn(state),
    translations: getTranslations(state),
    isWebRelaunchStyleEnabled: getWebRelaunchStyleEnabled(state),
    isLanguageChooserDisabled: getLanguageChooserDisabled(state),
    featureFlags: state.featureFlags
});

export const ConnectedRoot = connect(mapStateToProps)(Root);

export default withRouter(ConnectedRoot);
